// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Input, Loader, Toastr, Button, Label } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Actions Imports
import { UserActions } from "../../../actions";

// Internal Imports
import { GlobalUtils } from "../../../utils";
import { getValidDomainUrl } from "../../../actions/AuthActions/authMethods";

import REFERRALIMAGE from "../../../assets/referral-image.png";

// Destructuring
const {
  copyToClipBoard,
  validateEmail,
  readDataFromLocalStorage,
} = GlobalUtils;
const { referUsers, getAllTeammatesUsers } = UserActions;

class ReferralPopup extends Component {
  state = {
    btnLoader: false,
    isUpdate: false,
    resetUserRole: false,
    checkTeammate: null,
    userRole: {},
    inviteCode: "",
    textToCopy: "",
    buttonText: "Copy Link",
    emailArray: [],
    inviteEmail: "",
    errMsg: "",
  };

  componentDidMount() {
    let { inviteCode } = this.state;
    if (inviteCode === "") {
      this.setState({
        btnLoader: true,
      });
      const id =
        readDataFromLocalStorage("revvsalesUser").org_id.split("-")[1] ||
        readDataFromLocalStorage("revvsalesUser").org_id;
      inviteCode = id;
      this.setState({
        inviteCode,
        textToCopy: `${getValidDomainUrl()}/referral/`,
        btnLoader: false,
      });
    }
  }

  _closePopup = () => {
    this.props.closePopup("showReferralPopup", false);
  };

  _CopyTextToClipboard = () => {
    const copiedData = copyToClipBoard(
      this.state.textToCopy + this.state.inviteCode,
    );
    if (copiedData) {
      Toastr.showToastr({
        type: "success",
        message: "Invite link copied to clipboard.",
        timeout: 3000,
      });
      this.setState({
        buttonText: "Copied",
      });
    } else {
      Toastr.showToastr({
        type: "warning",
        message:
          "Could not copy invite link. Please highlight and select link and copy to clipboard.",
        timeout: 3000,
      });
    }
  };

  _handleInviteSubmit = () => {
    const { inviteEmail, isUpdate, checkTeammate } = this.state;
    const { emailArray } = this.state;
    if (inviteEmail) {
      if (!emailArray.includes(inviteEmail)) {
        emailArray.push(inviteEmail);
        this.setState({
          inviteEmail: "",
        });
      }
    }

    if (!inviteEmail && !emailArray.length) {
      this.setState({
        errMsg: "Enter at least one valid email address",
      });
    }
    const payload = this._getInviteTeammatePayload(emailArray);
    if (payload.length > 0) {
      const isInviteOrReInviteCase = !!checkTeammate;
      this.setState({
        errMsg: "",
        btnLoader: true,
      });
      const submitInvite = this.props.referUsers;
      submitInvite(payload, isInviteOrReInviteCase)
        .then(() => {
          Toastr.showToastr({
            className: "is-success",
            message: isUpdate
              ? "Successfully edited teammate's details"
              : "Email invite with your referral link has been sent to recipients",
            timeout: 2000,
          });
          this.setState({ btnLoader: false });
          this._closePopup();
        })
        .catch(error => {
          console.error(
            `ReferralPopup => _handleInviteSubmit => submitInvite => ${error}`,
          );
          let errorMsg = "Something went wrong..!!";
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.length > 0
          ) {
            const [tempError] = error.response.data.errors;
            if (tempError && tempError.Error && tempError.Error.message) {
              errorMsg = tempError.Error.message;
            }
          }
          this.setState({
            btnLoader: false,
            errMsg: errorMsg,
          });
        });
    }
  };

  _getInviteTeammatePayload = email => {
    const {
      inviteEmail,
      userRole,
      groupIds,
      isUpdate,
      checkTeammate,
    } = this.state;
    const { teammate } = this.props;

    let payload = [];
    let emailList = [];
    for (let i = 0; i < email.length; i += 1) {
      if (!validateEmail(email[i])) {
        this.setState({
          errMsg: `You have entered an invalid email id, please recheck`,
          btnLoader: false,
        });
        emailList = [];
        break;
      } else {
        emailList.push({
          user_email: email[i],
          roles: [{ id: userRole.id }],
        });
      }
    }

    let user;
    if (teammate && teammate.id) {
      user = teammate;
    } else if (checkTeammate) {
      user = checkTeammate;
    }
    if (user) {
      /**
       * If it is an edit invite or existing invite/re-invite user case then,
       * pass the two fields 'is_role_updated'
       * and 'is_usergroup_updated' along with user data
       */
      // const {
      //   isRoleUpdated,
      //   isUserGroupsUpdated,
      // } = this._checkRoleAndGroupChange(user);

      // for existing invite/re-invite
      payload = emailList;

      // for edit invite
      if (isUpdate) {
        const data = {
          user_email: inviteEmail,
          roles: [{ id: userRole.id }],
          usergroups: groupIds.map(groupId => ({
            id: groupId.id,
          })),
        };

        payload = {
          user: {
            ...data,
            id: teammate.id,
          },
          // is_role_updated: isRoleUpdated,
          // is_usergroup_updated: isUserGroupsUpdated,
        };
      }
    }
    // New invite
    else {
      payload = emailList;
    }
    return payload;
  };

  _handleKeyDown = evt => {
    if (evt.key === " " || evt.key === "Enter") {
      const value = this.state.inviteEmail.trim();
      if (value && !this.state.emailArray.includes(value)) {
        if (!validateEmail(value)) {
          this.setState({
            errMsg: "You have entered an invalid email id, please recheck",
          });
        } else {
          this.state.emailArray.push(this.state.inviteEmail);
          this.setState({
            inviteEmail: "",
            errMsg: "",
          });
        }
      } else {
        this.setState({
          errMsg: "email already present in the list",
        });
      }
    }
  };

  _checkInviteEmail = e => {
    e.preventDefault();
    const { inviteEmail } = this.state;

    if (inviteEmail) {
      const checkTeammate = this.props.teammatesList.find(
        teammate => teammate.user_email === inviteEmail,
      );
      if (checkTeammate) {
        const { roles } = checkTeammate;
        let userRole = {};
        if (roles.length > 0) {
          userRole = {
            id: roles[0].id,
            label: roles[0].name,
            value: roles[0].name,
          };
        }
        this.setState({
          checkTeammate,
          inviteEmail,
          userRole,
          resetUserRole: true,
        });
      }
    }
  };

  _onInputChange = e => {
    let trimedValue = e.target.value;
    if (trimedValue) {
      trimedValue = trimedValue.trim().toLocaleLowerCase();
    }
    const { resetUserRole, userRole } = this.state;
    this.setState({
      [e.target.name]: trimedValue,
      errMsg: "",
      checkTeammate: null,
      userRole: resetUserRole ? {} : userRole,
      resetUserRole: false,
    });
  };

  _handleEmailInput = () => {
    document.getElementById("myEmailInput").focus();
    return false;
  };

  _handleDelete = email => {
    const { emailArray } = this.state;
    for (let i = 0; i < emailArray.length; i += 1) {
      if (emailArray[i] === email) {
        emailArray.splice(i, 1);
      }
    }
    this.setState({
      emailArray,
    });
  };

  render() {
    const { errMsg, checkTeammate, inviteEmail, isUpdate } = this.state;
    const errMsgSpace = errMsg ? (
      <div className="error-message-wrapper">{errMsg}</div>
    ) : null;

    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        {(this.state.btnLoader || this.props.externalLoader) && (
          <Loader className="loader-bg-color" label="Please wait..." />
        )}

        <div>
          <div className="referral-modal-heading">
            Refer and get Amazon gift cards
            <span role="img" aria-label="gift-icon">
              {" "}
              🎁
            </span>
          </div>

          <div>{errMsgSpace}</div>

          <div>
            <img
              className="referral-img"
              src={REFERRALIMAGE}
              alt="referral-img"
            />
          </div>

          <div className="referral-text">
            Refer 3 of your clients, consultants or peers and get an Amazon gift
            card worth $75 after they sign-up successfully. For every additional
            referral you get a $50 Amazon gift card once they sign-up.
          </div>

          <div className="referral-popup-form">
            <div className="form-group referral-flex-display">
              <div className="referral-popup-link">
                <Label htmlFor="userEmail">
                  Here&apos;s your referral link.
                </Label>
                <div className="referral-popup-social">
                  <Input
                    className="referral-copy-invite-text"
                    type="text"
                    readOnly="readonly"
                    value={this.state.textToCopy + this.state.inviteCode}
                    disabled="false"
                  />
                  <Button
                    data-test="copy-invite-code"
                    type="button"
                    className="btn btn-primary referral-copy-button"
                    onClick={this._CopyTextToClipboard}>
                    {this.state.buttonText}
                  </Button>
                </div>
              </div>

              <div>
                <Label htmlFor="userEmail">Share on</Label>
                <div className="referral-popup-social">
                  <a
                    className="referral-facebook"
                    data-test="facebook share"
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                      this.state.textToCopy + this.state.inviteCode,
                    )}&quote=${encodeURIComponent(
                      `Gone are the days when I had to hunt for business templates and wait for days to close documents! Get your documents signed, sealed and delivered with Revv and use their stunning templates! Here’s a referral code that’ll get you a sweet discount too!
                      ${this.state.textToCopy + this.state.inviteCode}`,
                    )}`}>
                    <FontAwesomeIcon icon={["fab", "facebook"]} />
                  </a>
                  <a
                    className="referral-linkedin"
                    data-test="linkedin share"
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                      this.state.textToCopy + this.state.inviteCode,
                    )}`}>
                    <FontAwesomeIcon icon={["fab", "linkedin"]} />
                  </a>
                  <a
                    className="referral-twitter"
                    data-test="twitter share"
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://twitter.com/share?url=${encodeURIComponent(
                      this.state.textToCopy + this.state.inviteCode,
                    )}%0A&text=${encodeURIComponent(
                      `Gone are the days when I had to hunt for business templates or wait for days to get documents signed! I use Revv for all my business paperwork and it’s a 💯. Use my link to get 💵 credits.\n`,
                    )}&via=Revv_so&hashtags=referralonrevv`}>
                    <FontAwesomeIcon icon={["fab", "twitter"]} />
                  </a>
                </div>
              </div>
            </div>

            <div className="referral-popup-form-field">
              <Label htmlFor="userEmail">
                {isUpdate
                  ? "Email address"
                  : "Or, enter multiple emails here separated by space or enter"}
              </Label>
              <div
                role="button"
                onClick={this._handleEmailInput}
                onKeyDown={this._handleEmailInput}
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex="0"
                className={
                  isUpdate
                    ? "referral-popup-form-field"
                    : "referral-popup-form-field form-control focus"
                }>
                {this.state.emailArray.map((item, index) => (
                  <div className="referral-popup-tag-item" key={item}>
                    {item}
                    <Button
                      data-test="delete-email"
                      type="button"
                      className="referral-popup-button"
                      onClick={() => this._handleDelete(item, index)}>
                      &times;
                    </Button>
                  </div>
                ))}
                <input
                  data-test="add-multiple-emails"
                  id="myEmailInput"
                  className={
                    isUpdate ? "form-control" : "referral-popup-email-input"
                  }
                  type="text"
                  name="inviteEmail"
                  placeholder="You can enter more than one email IDs"
                  value={inviteEmail}
                  disabled={isUpdate}
                  onChange={isUpdate ? () => {} : this._onInputChange}
                  onBlur={isUpdate ? () => {} : this._checkInviteEmail}
                  onKeyDown={this._handleKeyDown}
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus
                />
              </div>
            </div>
          </div>
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              data-test="submit-popup-button"
              className="btn btn-primary"
              onClick={
                checkTeammate && checkTeammate.is_confirmed
                  ? () => {}
                  : this._handleInviteSubmit
              }
              disabled={checkTeammate && checkTeammate.is_confirmed}
              isLoading={this.state.btnLoader}>
              <b>Send Invite</b>
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { teammatesList, userGroups } = state.SettingsStore;
  return { teammatesList, userGroups };
};

const mapDispatchToProps = {
  referUsers: (users, flag) => referUsers(users, flag),
  getAllTeammatesUsers,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferralPopup);



// WEBPACK FOOTER //
// ./src/components/SettingsWrapper/ReferralPopup/index.js